import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isSessionActive } from './SessionExpiry';


import WrapperTools from '../../components/wrappers/WrapperTools';

function RouteTools({ component: Component, userName, token, expiry, clockOffset, ...rest }) {

  //catch missing required props
  if(!expiry || !token || !userName) {
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/tools/login", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //check expiry

  //check reducer store and local token values
  const validToken = (token === localStorage.getItem('tools-token'))? true : false;
  const validDate = isSessionActive(expiry, clockOffset);

  return(
        <Route
          {...rest}
          render={props =>
              (userName !== '' && validToken && validDate) ?
                  (<React.Suspense fallback={<WrapperTools inSuspense={true}/>}>
                    <Component {...props} />
                  </React.Suspense>) :
                  (<Redirect to={{ pathname: "/tools/logout", state: {from: props.location} }} /> )
          }
        />
  );
}

export default RouteTools;
